import Campaigns from 'modules/Services/CampaignsEditor/tableConfigs/campaigns'
import AdGroups from 'modules/Services/CampaignsEditor/tableConfigs/ad-groups'
import Banners from 'modules/Services/CampaignsEditor/tableConfigs/banners'

const FILTERS_MAP = {
  campaigns: Campaigns,
  'ad-groups': AdGroups,
  banners: Banners,
}

export default (resource) => (resource ? FILTERS_MAP?.[resource] : null)
